import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Card from "lib/Card";
import "./index.scss";
import Image from "lib/Image";
import Label from "lib/Label";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Accordion, Carousel, Col, Row } from "react-bootstrap";
import LoadingSpinner from "lib/LoadingSpinner";
import { removeUndefinedFromString, similarity, videoKYCAggregate } from "helper";
import { BASE_URL } from "constants/routes";
import { setDataMatchAggregate } from "redux/dashBoardDetailReducer";


const chooseColorCode = (value) => {
  if (parseInt(value) >= 85) {
    return "greenColour";
  } else if (parseInt(value) >= 50) {
    return "yellowColour";
  } else {
    return "redColour";
  }
};



function getBase64String(obj) {
  const { extension, ...rest } = obj;
  return Object.values(rest)[0];
}

const chooseColor = (value) => {
  if (parseInt(value) > 85) {
    return "#92ce6a";
  } else if (parseInt(value) > 60) {
    return "#e89200";
  } else {
    return "#ff6464";
  }
};

function GetCarousel(props) {
  const {
    name,
    data,
    handleChange,
    uploadedFile
  } = props;
  let video_kyc_doc = {
    "Passport": "passport_doc",
    "PAN": "pan_card"
  }


  const documentType = useSelector((state) => state?.vkycReducer?.uploadedDoc) || video_kyc_doc
  const currentSubWorkFlowId = useSelector((state) => state?.dashboardDetailReducer?.currentSubWorkFlowId);
  const [doc, setDoc] = useState("");
  const [uploadedDocs, setUploadedDocs] = useState([]);
  function handleSelect(value) {
    handleChange(name, value);
  }

 

  useEffect(() => {
    if (name === "uploaded") {
      if (data?.type?.toLowerCase() === "passport") {
        setDoc(documentType[data?.type]);
      } else if (data?.type?.toLowerCase() === "pan") {
        setDoc(documentType[data?.type]);
      }
    }
  }, [name])

  useEffect(() => {
    if (uploadedFile !== undefined) {
      let encrypted_filename = uploadedFile?.source_data[`${doc}`]?.encrypted_filename;
      let ext = uploadedFile?.source_data[`${doc}`]?.document_type;
      let extension = ext?.split(".")[1];
      let imageUrl = `${BASE_URL}/workflow/viewUploadedDocument/${currentSubWorkFlowId}/${doc}/${encrypted_filename}`;
      if (extension && imageUrl) {
        setUploadedDocs([{
          extension: extension,
          imageUrl: imageUrl
        }])
      }
    }
  }, [doc])
  const uploadedImages = name === "submitted" ? data : uploadedDocs;

  function base64ToBlob(base64Data, contentType) {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }


  const handleDownload = (e, item) => {
    e.preventDefault();
    if (item.front) {
      const blob = base64ToBlob
        (item.front, "application/pdf");
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Uploaded Document.pdf";
      link.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <Carousel indicators={uploadedImages?.length > 1} controls={uploadedImages?.length > 1}
    >
      {
        uploadedImages &&
        uploadedImages.map((item, index) => (
          <Carousel.Item key={index} style={{ position: "relative" }}>
            {item?.extension?.toLowerCase() === "pdf" && name === "uploaded" && (

              <div
                style={{
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "green",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}

              >

                <iframe src={`${item?.imageUrl}`} width="100%" title=""></iframe>
              </div>
            )}
            {item?.extension?.toLowerCase() !== "pdf" && name === "uploaded" && (
              <img
                style={{
                  height: "180px",
                  objectFit: "fill",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
                className="d-block w-100 border border-light-500 border-2"
                src={`${item?.imageUrl}`}
                alt="Slide"
              />
            )}
            {item?.extension.toLowerCase() === "pdf" && name === "submitted" && (

              <div
                style={{
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "green",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}

              >

                <iframe src={`data:application/pdf;base64,${getBase64String(item)} `} width="100%" title=""></iframe>
              </div>
            )}
            {item?.extension.toLowerCase() !== "pdf" && name === "submitted" && (
              <img
                style={{
                  height: "180px",
                  objectFit: "fill",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
                className="d-block w-100 border border-light-500 border-2"
                src={`data:application/pdf;base64,${getBase64String(item)} `}
                alt="Slide"
              />
            )}
          </Carousel.Item>
        ))
      }
    </Carousel>
  );
}

function VKyc(props) {
  const { selectedData } = props;
  const callbackData = useSelector((state) => state.vkycReducer.vkycResponse);
  const subworkFlowInfo = useSelector(
    (state) => state.dashboardDetailReducer?.userSubworkFlowInfo
  );

  const vcip_callback = selectedData?.subworkFlowInfo?.vcip_callback;


  let distinct_data = vcip_callback?.captured_images;
  let captured_images = [];
  let current = []
  distinct_data?.map((item) => {
    if (!current.includes(item.type)) {
      captured_images.push(item)
      current.push(item.type)
    }
  })
  const [VKyCDataArray, setVKyCDataArray] = useState([]);
  const [vkYCIndexToPick, setVkYCIndexToPick] = useState([]);
  const videoRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("uploaded");
  const [activeIndex, setActiveIndex] = useState(0);
  const [documentUploaded, setDocumentUploaded] = useState();
  const [documentCaptured, setDocumentCaptured] = useState();
  const [carouselIndex, setCarouselIndex] = useState({
    uploaded: 0,
    submitted: 0,
  });

  const [capturedImagesArray, setCapturedImagesArray] = useState([]);

  const workFlowInfoLoading = useSelector(
    (state) => state.dashboardDetailReducer?.userSubworkFlowInfoLoading
  );
  let preffered_kyc_keys = ["Name", "PAN_Number", "DOB", "Father_Name", "Passport_Number", "File Number", "Surname"]
  const dispatch = useDispatch()

  let document_uploaded = vcip_callback?.dkyc_request?.document_uploaded;
  let document_captured = vcip_callback?.dkyc_request?.document_captured;
  let match_result = vcip_callback?.match_result;
  let data_match_aggregate_demo;
  let is_documents_valid = false;

  if (vcip_callback?.dkyc_request?.document_uploaded[0]?.document_type?.toLowerCase() == vcip_callback?.dkyc_request?.document_captured[0]?.document_type?.toLowerCase()) {
    is_documents_valid = true;
    data_match_aggregate_demo = videoKYCAggregate(vcip_callback?.dkyc_request?.document_uploaded[0]?.user_data[0]?.vision, vcip_callback?.dkyc_request?.document_captured[0]?.user_data[0]?.vision, preffered_kyc_keys);
  }
  let keysToConsider = data_match_aggregate_demo?.keysToConsider || []
  let data_match_aggregate = data_match_aggregate_demo?.result || 0 + "%"
  data_match_aggregate = match_result?.data_match_aggregate ? match_result?.data_match_aggregate : data_match_aggregate
  if (data_match_aggregate) {
    dispatch(setDataMatchAggregate(data_match_aggregate))
  }
  const face_match_result = vcip_callback?.facial_match.filter((item) => {
    if (item?.type == "facial_match_aggregate") {
      return item
    }
  })
  let face_match_result_2 = vcip_callback?.dkyc_request?.document_captured[0]?.facial_match_percentage || vcip_callback?.dkyc_request?.document_uploaded[0]?.facial_match_percentage || vcip_callback?.dkyc_request?.facial_match_aggregate || 0
  face_match_result_2 = match_result?.facial_match_aggregate ? match_result?.facial_match_aggregate : face_match_result_2 + "%"
  const wfJourney = useSelector((state) => state?.configurationReducer?.config?.wf_journey);
  let field;
  wfJourney?.find((item) => {
    if (item?.module_name === 'video-kyc' || item?.module_name === 'video_kyc') {
      item?.capturing_documents?.find((key) => {
        field = key?.field;
        return field;
      })
    }
  })

  const [currentTime, setCurrentTime] = useState(0);
  const [hasRun, setHasRun] = useState(false);

  const vkyCResponseLoading = useSelector(
    (state) => state.vkycReducer?.vkyCResponseLoading
  );

  const customer_details = [
    {
      label: "Father's Name",
      value: subworkFlowInfo?.source_data?.father_name
    },
    {
      label: "Spouse Name",
      value: subworkFlowInfo?.source_data?.spouse_name
    },
    {
      label: "Contact Number",
      value: selectedData?.subworkFlowInfo?.mobile_number,
    },
    {
      label: "Reference Id",
      value: vcip_callback?.reference_id,
    },
    {
      label: "Customer Id",
      value: vcip_callback?.customer_id,
    },
  ];
  const vkyc_remarks = [
    {
      label: "RM VKYC APPROVAL NOTE",
      value: subworkFlowInfo?.source_data?.rm_vkyc_approve_remarks,
    },
    {
      label: "RM VKYC REJECTION NOTE",
      value: subworkFlowInfo?.source_data?.rm_vkyc_rejection_remarks,
    },
  ];


  const additional_details = [
    {
      label: "Date of Birth",
      value: selectedData?.subworkFlowInfo?.birth_date,
    },
    {
      label: "Gender",
      value: selectedData?.subworkFlowInfo?.vcip_callback?.extracted_data[0]?.data?.Gender,
    },
    {
      label: "Email",
      value: selectedData?.subworkFlowInfo?.email,
    },
    {
      label: "Address",
      value:
        selectedData?.subworkFlowInfo?.verification_response?.[field]?.address
      //  removeUndefinedFromString([selectedData?.subworkFlowInfo?.home_address_line1,selectedData?.subworkFlowInfo?.home_address_line2 ,selectedData?.subworkFlowInfo?.home_address_city,selectedData?.subworkFlowInfo?.home_landmark,selectedData?.subworkFlowInfo?.home_pincode,selectedData?.subworkFlowInfo?.home_district,selectedData?.subworkFlowInfo?.home_state,selectedData?.subworkFlowInfo?.home_country])
    },
  ];

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = currentTime;
      if (videoRef.current.paused) {
        videoRef.current.play();
      }
    }
  }, [currentTime]);

  const getTime = useCallback((milliseconds) => {
    let m = moment.utc(milliseconds);
    let mins = m.minutes();
    let secs = m.seconds();
    return `${mins < 10 ? `0${mins}` : mins} : ${secs < 10 ? `0${secs}` : secs
      }`;
  }, []);

  const handlePlayVideo = (newTime) => {
    const seconds = newTime / 1000;
    setCurrentTime(seconds);
  };


  useEffect(() => {
    setLoaded(true);
  }, [callbackData]);

  const handleCarouselChange = useCallback((name, value) => {
    setActiveTab(name);
    setActiveIndex(value);


    setCarouselIndex((prev) => ({ ...prev, [name]: value }));
  }, []);

  useEffect(() => {

    if (
      selectedData?.subworkFlowInfo?.vcip_callback?.uploaded_docs &&
      selectedData?.subworkFlowInfo?.vcip_callback?.captured_images
    ) {
      const callbackData = selectedData?.subworkFlowInfo?.vcip_callback;

      const capturedImages = callbackData?.captured_images.filter(
        (item) => item?.type !== "customer_live_photo"
      );
      const uploadedDocs = callbackData?.uploaded_docs.filter(
        (item) => item?.type !== "customer_live_photo"
      );

      const restCapturedImages = callbackData?.captured_images.filter(
        (item) => item?.type !== "customer_live_photo"
      );

      let newArray = [];

      restCapturedImages.map((object) => {
        newArray.push(object.content);
      });

      let flattenedArrayOfImages = [].concat(...newArray);

      setCapturedImagesArray(flattenedArrayOfImages);

      const finalData = callbackData?.captured_images.map((item) => {
        const submittedItem = callbackData?.uploaded_docs?.find(
          (submittedItem) => submittedItem?.type === item.type
        );
        return {
          captured: item,
          submitted: submittedItem,
        };
      });

      const filteredData = finalData.filter(
        (item) => item?.captured?.type === item.submitted?.type
      );
      let data_match_aggregate = 0;

      const firstKey = filteredData.map((item) => Object.keys(item)[0]);
      setVKyCDataArray(filteredData);
      setVkYCIndexToPick(firstKey);
      setHasRun(true);
    }
  }, [selectedData?.subworkFlowInfo?.vcip_callback]);

  const handleSelectTab = (key) => {
    if(key === "uploaded") setActiveTab("uploaded");
    else if(key === "submitted") setActiveTab("submitted");
  };

  const getCustomerLivePhoto = useCallback((item) => {
    const customerLivePhoto = item?.find(
      (image) => image.type === "customer_live_photo"
    ); 

    return customerLivePhoto?.content[0].customer_photo;
  }, []);

  const vcipCallback = selectedData?.subworkFlowInfo?.vcip_callback;

  let videoEle = document.getElementById("vkycVideo");
  let playBtn = document.querySelector(".btn-play");

  const playVideo = () => {
    videoEle.play();
    playBtn.classList.add("d-none");
  };
  const pauseVideo = () => {
    videoEle.pause();
    playBtn.classList.remove("d-none");
  };
  return (
    <>
      {((vkyCResponseLoading || workFlowInfoLoading)) ? (
        <LoadingSpinner className="loaderDimensionAndPosition" />
      ) : (
        <>
          {
            selectedData?.subworkFlowInfo &&
              selectedData?.subworkFlowInfo?.vcip_callback &&
              selectedData?.subworkFlowInfo?.vcip_callback?.dkyc_request
                ?.current_status === "Awaiting Approval" ? (
              <div className="kyc_details">
                <div className="kyc_details_container">
                  {subworkFlowInfo.source_data.rm_vkyc_approve_remarks ||
                    subworkFlowInfo.source_data.rm_vkyc_rejection_remarks ? (
                    <Card className="kyc_details_card">
                      <div className="kyc_details_header">
                        <p className="title">VKYC Remarks</p>
                      </div>
                      <div className=" p-3 row">
                        {vkyc_remarks.map((item) => (
                          <>
                            {item.value ? (
                              <div className="col-12 " key={item?.label}>
                                <div className="col-md-6 col-sm-12 mx-3">
                                  <label className="usercard_data ">
                                    {item?.label}:{" "}
                                  </label>
                                </div>
                                <div className="col-md-6 col-sm-12 mx-3">
                                  <div className="title semiBoldForvalue">
                                    {item?.value}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </>
                        ))}
                      </div>
                    </Card>
                  ) : null}

                  <Card className="kyc_details_card">
                    <div className="kyc_details_header">
                      <p className="title fontFamily">Customer Details</p>
                    </div>
                    <div className="kyc_details_inner_container">
                      <div className="row">
                        <div className="col-md-6 col-sm-12 details_container_left">
                          <Image
                            style={{
                              borderRadius: "50%",
                            }}
                            imageSrc={`data:image/png;base64,${getCustomerLivePhoto(
                              selectedData?.subworkFlowInfo?.vcip_callback
                                ?.captured_images
                            )}`}
                            className="profile_image"
                          />
                          <div
                            style={{
                              width: "inherit",
                            }}
                            className="match"
                          >
                            <span className="name fontFamily">
                              {selectedData?.subworkFlowInfo?.full_name}
                            </span>
                            <div
                              style={{
                                justifyContent: "space-between",
                              }}
                              className="d-flex"
                            >
                              <span className="fontFamily matchtext ">
                                {(face_match_result_2 ? face_match_result_2 : face_match_result_2)
                                  ? "Average Face Match"
                                  : "Average Face Match"}
                              </span>
                              <span

                                className={`fontFamily matchtext ${chooseColorCode(
                                  face_match_result_2 ? face_match_result_2 : face_match_result_2
                                )}`}
                              >
                                {face_match_result_2 ? face_match_result_2 : face_match_result_2}
                              </span>
                            </div>
                            <div className="slider">
                              <div
                                className={`slider-fill ${chooseColorCode(
                                  face_match_result_2 ? face_match_result_2 : face_match_result_2
                                )}`}
                                style={{
                                  backgroundColor: `${chooseColor(
                                    face_match_result_2 ? face_match_result_2 : face_match_result_2
                                  )}`,
                                  width: `${face_match_result_2 ? face_match_result_2 : face_match_result_2
                                    }`,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12 mt-2">
                          <div className="details_container_right">
                            {selectedData?.subworkFlowInfo?.vcip_callback
                              ?.response_time_stamp && (
                                <span>
                                  Created on:
                                  {moment(
                                    selectedData?.subworkFlowInfo?.vcip_callback
                                      ?.response_time_stamp
                                  ).format("DD/MM/YY hh:mm:ss A")}
                                </span>
                              )}
                            {selectedData?.subworkFlowInfo?.vcip_callback
                              ?.lastUpdated && (
                                <span className="text-secondary">
                                  Last Updated:{" "}
                                  {moment(
                                    selectedData?.subworkFlowInfo?.vcip_callback
                                      ?.response_time_stamp
                                  ).format("DD/MM/YY hh:mm:ss A")}
                                </span>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 justify-content-between">
                        <div className="col-md-5 col-sm-12">
                          {customer_details.map((item) => (
                            item?.value ?
                              <div className="row" key={item?.label}>
                                <div className="col-6">
                                  <label className="usercard_data ">
                                    {item?.label + ":"}{" "}
                                  </label>
                                </div>
                                <div className="col-6">
                                  <div className="title semiBoldForvalue text-end">
                                    {item?.value}
                                  </div>
                                </div>
                              </div> : null
                          ))}
                        </div>
                        <div className="col-md-5 col-sm-12">
                          {additional_details.map((item) => (
                            item?.value && item?.value != "NA" && (
                              <div className="row" key={item?.label}>
                                <div className="col-6">
                                  <label className="usercard_data ">
                                    {item?.label}:{" "}
                                  </label>
                                </div>
                                <div className="col-6">
                                  <div className="title semiBoldForvalue text-end">
                                    {item?.value}
                                  </div>
                                </div>
                              </div>
                            )))}
                        </div>
                      </div>

                      {vcip_callback?.extracted_data?.length > 0 &&
                        vcip_callback?.extracted_data
                          .filter((item) => item?.type !== "customer_live_photo")
                          .map((item, index) => (
                            <div className="row mt-2 m-lg-1 doc_details">
                              <div className="row ms-0">
                                <div
                                  className="col-lg-4 col-md-4 col-sm-12 d-flex p-0 "
                                  key={index}
                                >
                                  <div style={{ width: "100%" }} className="d-flex justify-content-between">
                                    <div className="col-md-6 col-sm-12 justifyContentForMatchStatus">
                                      <Label
                                        label={`${item?.type}: `}
                                        className="usercard_data mt-0 fontWeightBoldVCIp "
                                      />
                                      <div
                                        className={`face_match fontWeightBoldVCIp  ${chooseColorCode(
                                          face_match_result_2 ? face_match_result_2 : face_match_result_2
                                        )} `}
                                      >
                                        Face Match:
                                      </div>
                                      <div
                                        className={`data_match  fontWeightBoldVCIp ${chooseColorCode(
                                          data_match_aggregate
                                        )}`}
                                      >
                                        Data Match:
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 fontWeightBoldVCIp justifyContentForMatchStatus">
                                      <div
                                        className={`usercard_data mt-0 fontWeightBoldVCIp wordWrapBreak text-end`}
                                      >
                                        {
                                          item?.data?.Passport_Number ||
                                          item?.data?.PAN_Number
                                        }

                                      </div>

                                      <div
                                        className={`face_match wordWrapBreak fontWeightBoldVCIp text-end ${chooseColorCode(
                                          face_match_result_2 ? face_match_result_2 : face_match_result_2
                                        )} `}
                                      >
                                        {
                                          face_match_result_2 ? face_match_result_2 : face_match_result_2
                                        }

                                      </div>
                                      <div
                                        className={`data_match wordWrapBreak fontWeightBoldVCIp text-end ${chooseColorCode(
                                          data_match_aggregate
                                        )}`}
                                      >
                                        {data_match_aggregate ? data_match_aggregate : 0}
                                      </div>
                                    </div>
                                  </div>
                                  {
                                    // if callbackData?.document_captured?.length < index + 1 then show vertical separator else not
                                    index + 1 <
                                    selectedData?.subworkFlowInfo?.vcip_callback
                                      ?.captured_images?.length -
                                    1 && (
                                      <div className="verticalSepartor"></div>
                                    )
                                  }
                                </div>
                              </div>{" "}
                            </div>
                          ))}

                      
                    </div>
                  </Card>

                  <Card className="kyc_details_card">
                    <div className="kyc_details_header">
                      <p className="title">V-CIP Details</p>
                    </div>
                    <div className="kyc_details_inner_container">
                      <div className="row video-position-mobile">
                        <div className="col-lg-6 col-md-12 col-sm-12 p-0">
                          <div className="row">
                            <div className="col-12 p-0">
                              <div className="question_row">
                                <span className="question_title mx-0">
                                  Questions Asked
                                </span>
                                {vcip_callback?.questions.map(
                                  (question, index) => {
                                    return (
                                      <div className="question" key={index}>
                                        {vcip_callback?.dkyc_request
                                          ?.dkyc_questions_info
                                          ?.dkyc_questions_time[index] && "("}
                                        {
                                          vcip_callback?.dkyc_request
                                            ?.dkyc_questions_info
                                            ?.dkyc_questions_time[index] && (
                                            <span
                                              className="question_time"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                handlePlayVideo(
                                                  vcip_callback?.dkyc_request
                                                    ?.dkyc_questions_info
                                                    ?.dkyc_questions_time[index]
                                                )
                                              }
                                            >
                                              {getTime(
                                                vcip_callback?.dkyc_request
                                                  ?.dkyc_questions_info
                                                  ?.dkyc_questions_time[index]
                                              )}
                                            </span>
                                          )
                                        }
                                        {vcip_callback?.dkyc_request
                                          ?.dkyc_questions_info
                                          ?.dkyc_questions_time[index] && ") "}
                                        <label className="question_text semiBoldForvalue">
                                          {question}
                                        </label>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              {vcip_callback?.liveness_record_info?.dkyc_questions
                                ?.length > 0 && (
                                  <div className="question_row">
                                    <span className="question_title mx-0">
                                      Liveness Detection
                                    </span>
                                    {callbackData?.liveness_record_info?.dkyc_questions.map(
                                      (question, index) => {
                                        return (
                                          <div className="question" key={index}>
                                            {"("}
                                            <span
                                              className="question_time"
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                handlePlayVideo(
                                                  callbackData?.liveness_record_info
                                                    ?.dkyc_questions_time[index]
                                                )
                                              }
                                            >
                                              {getTime(
                                                callbackData?.liveness_record_info
                                                  ?.dkyc_questions_time[index]
                                              )}
                                            </span>
                                            {") "}
                                            <label className="question_text semiBoldForvalue">
                                              {question}
                                            </label>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 position-relative video">
                          <video
                          onClick={()=>{
                            pauseVideo()
                          }}
                            style={{
                              borderRadius: "5px",
                            }}
                            ref={videoRef}
                            onPlay={() => {
                              videoRef.current.currentTime = currentTime;
                            }}
                            className="kyc-video"
                            controls
                            src={vcip_callback?.recorded_video?.video_link}
                            autoPlay={false}
                            seekable="true"
                            poster={`data:image/png;base64,${getCustomerLivePhoto(
                              selectedData?.subworkFlowInfo?.vcip_callback
                                ?.captured_images
                            )}`}
                            width="620"
                            preload="none"
                            muted={true}
                            id="vkycVideo"
                          >
                            Sorry, your browser doesn't support embedded videos,
                            but don't worry, you can
                            <a href="https://archive.org/details/BigBuckBunny_124">
                              download it
                            </a>
                            and watch it with your favorite video player!
                          </video>
                          <div className="d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle">
                            <div
                              className="border border-white border-4 rounded-circle w-50px h-50px d-flex align-items-center justify-content-center btn-play shadow-circle cursor-pointer"
                              onClick={() => playVideo()}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9.796"
                                height="13.271"
                                viewBox="0 0 9.796 13.271"
                                className="ms-1"
                              >
                                <path
                                  id="play-button_1_"
                                  data-name="play-button (1)"
                                  d="M15.159,6.375,6,.056a.316.316,0,0,0-.5.26v12.64a.316.316,0,0,0,.5.26L15.159,6.9a.316.316,0,0,0,0-.52Z"
                                  transform="translate(-5.5)"
                                  fill="#fff"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                     
                    
                      </div>
                      <div className="row mt-3 m-lg-1 doc_details">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-12 status d-flex">
                            <div style={{ width: "100%" }}>
                              {selectedData?.subworkFlowInfo?.status && (
                                <div className="row">
                                  <div className="col-md-6 col-sm-12 col-6">
                                    <span className="text-secondary semiBoldForvalue fSize15">
                                      Status:{" "}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                    <span className="status_text font-weight-bold text-sm">
                                      {selectedData?.subworkFlowInfo?.status}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {selectedData?.subworkFlowInfo?.vcip_callback
                                ?.geo_location?.latitude !== undefined && (
                                  <div className="row">
                                    <div className="col-md-6 col-sm-12 col-6">
                                      <span className="text-secondary semiBoldForvalue fSize15">
                                        Latitude:{" "}
                                      </span>
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                      <span className=" font-weight-bold text-sm">
                                        {selectedData?.subworkFlowInfo
                                          ?.vcip_callback?.geo_location
                                          ?.latitude === ""
                                          ? "NA"
                                          : selectedData?.subworkFlowInfo
                                            ?.vcip_callback?.geo_location
                                            ?.latitude}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              {vcip_callback?.recorded_video
                                ?.recording_started_at && (
                                  <div className="row">
                                    <div className="col-md-6 col-sm-12 col-6">
                                      <span className="text-secondary semiBoldForvalue fSize15">
                                        Recording Started:{" "}
                                      </span>
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                      <span className=" font-weight-bold text-sm">
                                        {moment(
                                          vcip_callback?.recorded_video
                                            ?.recording_started_at
                                        ).format("DD-MM-YYYY hh:mm A")}
                                      </span>
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div className="verticalSepartor"></div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 status">
                            {vcip_callback?.geo_location?.location !==
                              undefined && (
                                <div className="row">
                                  <div className="col-md-6 col-sm-12 col-6">
                                    <span className="text-secondary semiBoldForvalue fSize15">
                                      Location:{" "}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                    <span className=" font-weight-bold text-sm">
                                      {vcip_callback?.geo_location?.location === ""
                                        ? "NA"
                                        : vcip_callback?.geo_location?.location}
                                    </span>
                                  </div>
                                </div>
                              )}

                            {vcip_callback?.geo_location?.longitude !==
                              undefined && (
                                <div className="row">
                                  <div className="col-md-6 col-sm-12 col-6">
                                    <span className="text-secondary semiBoldForvalue fSize15">
                                      Longitude:{" "}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                    <span className=" font-weight-bold text-sm">
                                      {vcip_callback?.geo_location?.longitude === ""
                                        ? "NA"
                                        : vcip_callback?.geo_location?.longitude}
                                    </span>
                                  </div>
                                </div>
                              )}
                            {vcip_callback?.recorded_video
                              ?.recording_ended_at && (
                                <div className="row">
                                  <div className="col-md-6 col-sm-12 col-6">
                                    <span className="text-secondary semiBoldForvalue fSize15">
                                      Recording Ended:{" "}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-sm-12 col-6 align-text-end">
                                    <span className=" font-weight-bold text-sm">
                                      {moment(
                                        vcip_callback?.recorded_video
                                          ?.recording_ended_at
                                      ).format("DD-MM-YYYY hh:mm A")}
                                    </span>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      {vcip_callback?.dkyc_request?.consent_accepted ? (
                        <div className="row mt-3 consent_container m-lg-1">
                          <div className="consent_heading">
                            {vcip_callback?.dkyc_request?.consent_accepted
                              ?.accepted_at ? (
                              <>
                                Consent{" "}
                                <span className="consent_agreed_at">
                                  {" Agreed on : " +
                                    moment(
                                      vcip_callback?.dkyc_request
                                        ?.consent_accepted?.accepted_at
                                    ).format("DD-MM-YYYY hh:mm A")}
                                </span>
                              </>
                            ) : null}
                          </div>
                          <div className="consent_body">
                            {vcip_callback?.dkyc_request?.consent_accepted?.consent_text?.map(
                              (consent, index) => {
                                return <div key={index}>{consent?.details}</div>;
                              }
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </Card>

                  <Card className="kyc_details_card">
                    <div className="kyc_details_header">
                      <p className="title">KYC Details</p>
                    </div>
                    {
                      selectedData?.subworkFlowInfo &&
                        vcip_callback?.captured_images.length > 0 &&
                        captured_images.filter(
                          (item) =>
                            item?.type !== "customer_live_photo" &&
                            item?.type !== "Wet Signature"

                        ).length > 0 ? (
                        captured_images
                          .filter(
                            (item) =>
                              item?.type !== "customer_live_photo" &&
                              item?.type !== "Wet Signature"

                          )
                          .map((item, index) => (
                            <div
                              key={index}
                              className="kyc_details_inner_container"
                            >
                              <div className="row d-flex align-items-center justify-content-center">
                                <div className="col-4 col-lg-8 col-md-4 col-sm-4">
                                  <p className="font-weight-bold">{item?.type}</p>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                  }}
                                  className="col-8 col-lg-4 col-md-4 col-sm-4 pt-2 d-flex "
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    className={`p-0 font-weight-bold ${chooseColorCode(
                                      data_match_aggregate
                                    )} `}
                                  >
                                    Data Match :

                                    <span className="ml-2">
                                      &nbsp;
                                      {data_match_aggregate ? data_match_aggregate : 0}

                                    </span>
                                  </span>
                                  <span className="p-0 font-weight-bold miniverticalSepartor"></span>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    className={`p-0 font-weight-bold ${chooseColorCode(
                                      face_match_result_2 ? face_match_result_2 : face_match_result_2
                                    )} `}
                                  >
                                    Face Match:

                                    <span className=" ml-2">
                                      &nbsp;

                                      {face_match_result_2 ? face_match_result_2 : face_match_result_2}

                                    </span>
                                  </span>

                                </div>
                              </div>

                              <div className="row d-flex justify-content-between">
                                <div className="row md-12 d-flex col-md-6 col-12">
                                  <Tabs
                                    id="controlled-tab-example"
                                    defaultActiveKey={"submitted"}
                                    activeKey={activeTab}
                                    onSelect={handleSelectTab}
                                    className="mt-2 mb-3 mx-3 detail-nav-tabs w-100 justify-content-evenly"
                                    fill
                                  >
                                    {selectedData?.subworkFlowInfo?.vcip_callback
                                      ?.uploaded_docs?.[index] && (
                                        <Tab eventKey="uploaded" title="Uploaded">
                                          <GetCarousel
                                            name="uploaded"
                                            activeKey={
                                              
                                              activeTab === "uploaded" ? 0 : 1
                                            }
                                            activeIndex={
                                             
                                              activeIndex
                                            }
                                            handleChange={handleCarouselChange}
                                            data={
                                              selectedData?.subworkFlowInfo
                                                ?.vcip_callback?.uploaded_docs?.[
                                              index || 0
                                              ]
                                            }
                                            uploadedFile={subworkFlowInfo}
                                            key="uploaded"
                                          />
                                        </Tab>
                                      )}
                                    {selectedData?.subworkFlowInfo?.vcip_callback
                                      ?.captured_images?.[index] && (
                                        <Tab eventKey="submitted" title="Captured">
                                          <GetCarousel
                                            name="submitted"
                                            activeKey={
                                             
                                              activeTab === "uploaded" ? 0 : 1
                                            }
                                            activeIndex={
                                              
                                              activeIndex
                                            }
                                            handleChange={handleCarouselChange}
                                            data={
                                              

                                              capturedImagesArray
                                            }
                                          />
                                        </Tab>
                                      )}
                                  </Tabs>
                                </div >
                              { match_result === undefined ? (

                                <div className="row md-12 d-flex col-md-6 col-12">

                                  {vcip_callback?.extracted_data && (
                                    <div className="col-md-6 col-sm-12 d-flex">
                                      <div className="w-100">
                                        <p className="font-weight-bold">
                                          OCR data
                                        </p>

                                        <div className="ocr_data">
                                          {
                                            (document_uploaded[0]?.user_data[0].vision?.Name && document_captured[0]?.user_data[0].vision?.Name && keysToConsider?.includes('Name')) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary">
                                                  Name
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.Name
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_uploaded[0]?.user_data[0].vision?.Surname && document_captured[0]?.user_data[0].vision?.Surname) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Surname
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.Surname
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_uploaded[0]?.user_data[0].vision?.PAN_Number && document_captured[0]?.user_data[0].vision?.PAN_Number) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Pan Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.PAN_Number
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_uploaded[0]?.user_data[0].vision?.Passport_Number && document_captured[0]?.user_data[0].vision?.Passport_Number) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Passport Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.Passport_Number
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_uploaded[0]?.user_data[0].vision?.DOB && document_captured[0]?.user_data[0].vision?.DOB) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Date of Birth
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.DOB
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_captured[0]?.user_data[0].vision?.Father_Name && document_uploaded[0]?.user_data[0].vision?.Father_Name) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Father Name
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision?.Father_Name
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (document_uploaded[0]?.user_data[0].vision["File Number"] && document_captured[0]?.user_data[0].vision["File Number"] != "NA") && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  File Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    document_uploaded[0]?.user_data[0].vision["File Number"]
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          marginTop: "77px",
                                          height: "200px",
                                        }}
                                        className="verticalSepartor"
                                      ></div>
                                    </div>
                                  )}
                                  {vcip_callback?.dkyc_request?.document_captured?.[
                                    index
                                  ]?.is_captured ? (
                                    <div className="col-md-6 col-sm-12 d-flex">
                                      <div className="w-100">
                                        <p className="font-weight-bold">
                                          Authenticated data
                                        </p>
                                        {is_documents_valid &&
                                          <div className="ocr_data col-md-12">
                                            {
                                              (document_captured[0]?.user_data[0].vision?.Name && document_uploaded[0]?.user_data[0].vision?.Name) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary">
                                                    Name
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>

                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.Name
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ms-3 ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Name,
                                                          document_captured[0]?.user_data[0].vision?.Name
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Name,
                                                          document_captured[0]?.user_data[0].vision?.Name
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision?.Surname && document_uploaded[0]?.user_data[0].vision?.Surname) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Surname
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>

                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.Surname
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Surname,
                                                          document_captured[0]?.user_data[0].vision?.Surname
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Surname,
                                                          document_captured[0]?.user_data[0].vision?.Surname
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision?.PAN_Number && document_uploaded[0]?.user_data[0].vision?.PAN_Number) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Pan Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.PAN_Number
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.PAN_Number,
                                                          document_captured[0]?.user_data[0].vision?.PAN_Number
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.PAN_Number,
                                                          document_captured[0]?.user_data[0].vision?.PAN_Number
                                                        ) + "%"
                                                      }

                                                    </span>

                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision?.Passport_Number && document_uploaded[0]?.user_data[0].vision?.Passport_Number) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Passport Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.Passport_Number
                                                      }
                                                    </span>

                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Passport_Number,
                                                          document_captured[0]?.user_data[0].vision?.Passport_Number
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Passport_Number,
                                                          document_captured[0]?.user_data[0].vision?.Passport_Number
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision?.DOB && document_uploaded[0]?.user_data[0].vision?.DOB) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Date of Birth
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.DOB
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.DOB,
                                                          document_captured[0]?.user_data[0].vision?.DOB
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.DOB,
                                                          document_captured[0]?.user_data[0].vision?.DOB
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision?.Father_Name && document_uploaded[0]?.user_data[0].vision?.Father_Name) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Father Name
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision?.Father_Name
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Father_Name,
                                                          document_captured[0]?.user_data[0].vision?.Father_Name
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision?.Father_Name,
                                                          document_captured[0]?.user_data[0].vision?.Father_Name
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (document_captured[0]?.user_data[0].vision["File Number"] && document_uploaded[0]?.user_data[0].vision["File Number"] && document_captured[0]?.user_data[0].vision["File Number"] != "NA") && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    File Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        document_captured[0]?.user_data[0].vision["File Number"]
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision["File Number"],
                                                          document_captured[0]?.user_data[0].vision["File Number"]
                                                        )
                                                      )}`}
                                                    >
                                                      {
                                                        similarity(
                                                          document_uploaded[0]?.user_data[0].vision["File Number"],
                                                          document_captured[0]?.user_data[0].vision["File Number"]
                                                        ) + "%"
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}

                                          </div>
                                        }
                                      </div>

                                    </div>
                                  ) : null}

                                </div>
                               ) : ( 
                                <div className="row md-12 d-flex col-md-6 col-12">

                                  {match_result?.document_uploaded && (
                                    <div className="col-md-6 col-sm-12 d-flex">
                                      <div className="w-100">
                                        <p className="font-weight-bold">
                                          OCR data
                                        </p>
                                        {/* <div className="ocr_data">
                                          {
                                            (match_result?.document_uploaded?.map(([key, value])=>{
                                              if(match_result?.document_captured?.hasOwnProperty(key)){
                                                <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary">
                                                  {key}
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    value
                                                  }
                                                </span>
                                              </div>
                                              }
                                            }))
                                            
                                            }
                                          </div> */}
                                        <div className="ocr_data">
                                          {
                                            (match_result?.document_uploaded?.Name && match_result?.document_captured?.Name && keysToConsider?.includes('Name')) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary">
                                                  Name
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.Name
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_uploaded?.Surname && match_result?.document_captured?.Surname) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Surname
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.Surname
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_uploaded?.PAN_Number && match_result?.document_captured?.PAN_Number) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Pan Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.PAN_Number
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_uploaded?.Passport_Number && match_result?.document_captured?.Passport_Number) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Passport Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.Passport_Number
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_uploaded?.DOB && match_result?.document_captured?.DOB) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Date of Birth
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.DOB
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_captured?.Father_Name && match_result?.document_uploaded?.Father_Name) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  Father Name
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded?.Father_Name
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          {
                                            (match_result?.document_uploaded["File Number"] && match_result?.document_captured["File Number"] != "NA") && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span className="text-secondary mt-3">
                                                  File Number
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="semiBoldForvalue"
                                                >
                                                  {
                                                    match_result?.document_uploaded["File Number"]
                                                  }
                                                </span>
                                              </div>
                                            )}
                                          
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          marginTop: "77px",
                                          height: "200px",
                                        }}
                                        className="verticalSepartor"
                                      ></div>
                                    </div>
                                  )}
                                  {match_result?.document_captured ? (
                                    <div className="col-md-6 col-sm-12 d-flex">
                                      <div className="w-100">
                                        <p className="font-weight-bold">
                                          Authenticated data
                                        </p>
                                        {is_documents_valid &&
                                          <div className="ocr_data col-md-12">
                                            {
                                              (match_result?.document_captured?.Name && match_result?.document_uploaded?.Name) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary">
                                                    Name
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>

                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.Name
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ms-3 ${chooseColorCode(
                                                        match_result?.data_match_percentage?.Name
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.Name
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured?.Surname && match_result?.document_uploaded?.Surname) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Surname
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>

                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.Surname
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage?.Surname
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.Surname 
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured?.PAN_Number && match_result?.document_uploaded?.PAN_Number) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Pan Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.PAN_Number
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage?.PAN_Number
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.PAN_Number
                                                      }

                                                    </span>

                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured?.Passport_Number && match_result?.document_uploaded?.Passport_Number) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Passport Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.Passport_Number
                                                      }
                                                    </span>

                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage?.Passport_Number
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.Passport_Number
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured?.DOB && match_result?.document_uploaded?.DOB) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Date of Birth
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.DOB
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage?.DOB
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.DOB
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured?.Father_Name && match_result?.document_uploaded?.Father_Name) && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    Father Name
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured?.Father_Name
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage?.Father_Name
                                                        
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage?.Father_Name
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            {
                                              (match_result?.document_captured["File Number"] && match_result?.document_uploaded["File Number"] && match_result?.document_captured["File Number"] != "NA") && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <span className="text-secondary mt-3">
                                                    File Number
                                                  </span>
                                                  <div style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                  }}>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                      className="semiBoldForvalue"
                                                    >
                                                      {
                                                        match_result?.document_captured["File Number"]
                                                      }
                                                    </span>
                                                    <span
                                                      className={`p-0 fontWeightBoldVCIp ${chooseColorCode(
                                                        match_result?.data_match_percentage["File Number"]
                                                      )}`}
                                                    >
                                                      {
                                                        match_result?.data_match_percentage["File Number"]
                                                      }

                                                    </span>
                                                  </div>
                                                </div>
                                              )}

                                          </div>
                                        }
                                      </div>

                                    </div>
                                  ) : null}

                                </div>
                               )
                                
                              }
                              </div>
                            </div>
                          ))
                      ) : (
                        <div className="p-3 px-4">No Details Added</div>
                      )}
                  </Card>
                </div>
              </div>
            ) : (
              <>
                {selectedData?.subworkFlowInfo?.vcip_response?.re_initiate ? (
                  <div className="p-3 px-4">Video KYC has been re-initiated</div>) :
                  (<div className="p-3 px-4">No Details Added</div>)
                }
              </>
            )}
        </>
      )}
      </>
  
  );
}

export default VKyc;
